import { render, staticRenderFns } from "./RadiusBox.vue?vue&type=template&id=66fd4400&scoped=true&"
import script from "./RadiusBox.vue?vue&type=script&lang=js&"
export * from "./RadiusBox.vue?vue&type=script&lang=js&"
import style0 from "./RadiusBox.vue?vue&type=style&index=0&id=66fd4400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd4400",
  null
  
)

export default component.exports